// extracted by mini-css-extract-plugin
export default {"AnswerBox":"session-grid-row_AnswerBox__eSL9H"};